import { HighlightOff } from '@mui/icons-material';
import { Button } from '@mui/material';
import { debounce } from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ClearFilterBtn = ({
  selectedFilters,
  setSelectedFilters,
  initState,
  setQuickDate,
}) => {
  const { t } = useTranslation('bulk');

  const handleDisableClear = filters =>
    !!filters.selectedDealers.dealers.length ||
    !!filters.selectedDepartments.departments.length ||
    !!filters.selectedServices.services.length ||
    !!filters.selectedSteps.steps.length;

  const setQuickDateDefault = debounce(() => {
    setQuickDate('week');
  }, 1);

  const handleClear = () => {
    setSelectedFilters(initState);
    setQuickDate(null);
    setQuickDateDefault();
  };

  return (
    <Button
      variant="text"
      disabled={!handleDisableClear(selectedFilters)}
      startIcon={<HighlightOff fontSize="small" />}
      onClick={handleClear}
    >
      {t('clearFilters')}
    </Button>
  );
};

export default ClearFilterBtn;
